import apiClient from "./apiClient";
import TokenManager from "./TokenManager";

class AuthService {
  static async login(username, password) {
    try {
      const response = await apiClient.post("/login/access-token", {
        username,
        password,
      });

      return response;
    } catch (error) {
      throw error;
    }
  }

  static async fetchNewToken() {
    const credentials = TokenManager.getStoredCredentials();

    if (!credentials?.username || !credentials?.password) {
      throw new Error("No stored credentials available");
    }

    try {
      const response = await apiClient.post("/login/access-token", {
        username: credentials.username,
        password: credentials.password,
      });

      const newToken = response.data.access_token;
      TokenManager.store(newToken);
      return newToken;
    } catch (error) {
      TokenManager.clear();
      throw error;
    }
  }

  static getStoredToken() {
    return TokenManager.retrieve();
  }

  static clearStoredToken() {
    TokenManager.clear();
  }

  static isTokenValid() {
    const token = TokenManager.retrieve();
    return TokenManager.isValid(token);
  }
}

export default AuthService;
